
import BaseView from "@core/View.js";
import Alert from "@util/alert.js";
import { $util } from "@util/util.js";
import API from "@api/index.js";
export default class PersonalGoodsPCView extends BaseView {
    constructor(model) {
        super(model);
        this._model._view = this;
        this._codes = ''
        this.indexRight = ''
        this.indexLeft = ''
        this._coder = ''
        // console.log('私人订制页面',this._model);
        // this._parentEl = this._model._parent._view._similarityBoxEl;
        this._el = null;
        this.materialCode = '';
        this.ptMode = null;
        this.submitInfo = null;
        this.selectedFontId = null; 
        this.ttfUrl = null;
        this.fontName = null;
        this.selectedFontFamily = null;
    }
    setSubmitInfo(v){
      this.submitInfo = v;
    }
    setPtUrl(v){
      this.ptUrl = v;
    }
    setPtMode(v){
      this.ptMode = v;
    }
    navItemList() {
        // console.log(this._model._parent._personalGoods,'that._personalGoods._aSideData')
        let arr = this._model._parent._personalGoods._aSideData
        let htmls = ``
        arr.forEach((item, index) => {
            htmls += `<li tag="onClicknavLi" codeNav="${item.code}" price="${item.price}" priceName="${item.showPrice}" index="${index}">${item.showPrice}</li>`
        })
        return htmls

    }
    slideLeftList() {
        let arr = this._model._parent._personalGoods._pictures
        let htmls = ``
        arr.forEach((item, index) => {
            htmls += `<li tag="onClickslideLi" codea="${item.cateCode}"  index="${index}">${item.cateName}</li>`
        })
        return htmls
    }
    typeItemList(res) {
        let html = ''
        res.map((item, index) => {
            let htmls = ''
            html += `<ul class="clearfix type_list">
            ${item.picArr.map((items, indexs) => {
                htmls += `<li tag="onMouseoverTag" name="${items.name}" data-large="${items.path}" code="${items.code}" >
                    <p class="thumb">
                        <img src="${items.path}" />
                        <div class='thumbNames'>${items.name}</div>
                    </p>
                </li>`
            }),
                htmls
                }
            </ul>`
        })

        return html
    }
    setButtonShowHide() {
        var self = this;
        if (self.page >= self.totalPage) {
            $('#srdz_style_bottombtn').removeClass('visible');
        } else {
            $('#srdz_style_bottombtn').addClass('visible');
        }
        if (self.page <= 1) {
            $('#srdz_style_topbtn').removeClass('visible');
        } else {
            $('#srdz_style_topbtn').addClass('visible');
        }
    }
    scrollButtonEvent(index) {
        var self = this;
        var count = this._model._parent._personalGoods._pictures.length;
        self.index = index
        self.w = 0;
        self.page = 1
        if (count == 0) {
            self.totalPage = 1;
        } else {
            self.totalPage = count % 10 == 0 ? count / 10 : parseInt(count / 10) + 1;
        }
        self.scrollHeight = $('.slide_content').height();
        $(".slide_content").find('ol.type').css({ top: 0 + "px" })


    }

    type_boxList() {
        let arr = this._model._parent._personalGoods._pictures
        let html = ''
        arr.forEach((item, index) => {
            this.scrollButtonEvent(index)
            html += `<div class="type_item">
            <div class="fl type_slide">
              <div class="prev" tag="srdz_style_topbtn" id="srdz_style_topbtn">
                <i class="iconfont icon-arrow-top"></i>
              </div>
              <div class="slide_content">
                <ol class="type">
                  ${this.slideLeftList(item)}
                </ol>
              </div>
              <div class="next" tag="srdz_style_bottombtn" id="srdz_style_bottombtn">
                <i class="iconfont icon-arrow-bottom"></i>
              </div>
            </div>
            <div class="fl type_content">
              <div class="type_list_box">
                ${this.typeItemList(arr)}
              </div>
              <div class="large_img_area">
                <img src="" />
              </div>
            </div>
          </div>`
        })
        return html
    }
    // 渲染喷绘（仅官喷） 笔记本、平板、台式机
    setItempersonal() {
      let isTablet = this._model._parent._personalGoods.machineInfo?.machineProductType === 'T';
        let datas = '';
        this._model._parent._data.personalizations.map((item, index) => {
            if (item.ptside == 'A' || item.ptside == 'L') {
                datas = item;
            }
        });
        let machineInfo = this._model._parent._personalGoods?.machineInfo || {};
        let html = ` <h2><i class="fr iconfont icon-close close_personal" tag="presonalCancel"></i>A面私人定制信息</h2>
        <div class="srdz_option_list">
        <div class='sdfsdf'>
            <ul class="clearfix nav">
                ${this.navItemList()}
            </ul>
        </div>
          <div class="clearfix personal_type_box">
                ${this.type_boxList()}
          </div>
        </div>
        <div class="personal_bottom">
          <button  class="le_btn le_btn_solid cancel" tag="presonalCancel">关闭</button>
          <button class="le_btn le_btn_solid confirm" tag="presonalOk">确认</button>         
        </div>`
        let Ahtml = `
            <h3>A面喷绘<span class="title_desc" latag="latag_pc_购物车_A面私定弹层_0_null_哪里为A/C面说明">哪里为A/C面？</span><img class="personal_text_close" latag="latag_pc_购物车_A面私定弹层_0_null_A面喷绘取消" src="//p4.lefile.cn/product/adminweb/2021/08/03/3Bg8XXy391KuwuDypqptVix4J-3323.png"></h3>
            <div class="personal_img_content">
                <div class="personal_img_content_l">
                    <img class='previewInkjetImg' src="" thumb_src=''>
                </div>
                <div class="personal_img_content_r">
                    <div class="personal_img_price_nav A_price_nav_box">
                        <ul class="A_price_nav_ul">
     
                        </ul>
                    </div>
                    <div class="personal_imgs_box">

                    </div>
                    <div class="personal_img_content_r_foot">
                        <b>喷绘价:¥1000</b><s>¥9999</s>
                        <div class="personal_text_C_cancel" latag="latag_pc_购物车_私定弹层_0_null_A面喷绘取消">取消</div>
                        <div class="personal_text_C_ensure sideA_submitOk" latag="latag_pc_购物车_私定弹层_0_null_A面喷绘确定">确定</div>
                    </div>
                </div>
            </div>
            <div class="a_c_desc">
                <div class="desc_title">A面定义</div>
                <img class="desc_pric" src="https://item.lenovo.com.cn/series/product/xiaoxin/images/srdz_a_pic.jpeg" >
                <div class="desc_text">
                    即顶盖，是指合上屏幕就看到的那一面，也就是笔记本logo所在的那一面                     
                </div>
                <div class="desc_title">C面定义</div>
                <img class="desc_pric" src="https://item.lenovo.com.cn/series/product/xiaoxin/images/srdz_c_pic.jpeg" >
                <div class="desc_text">即键盘所在面（但不包括键盘）</div>
            </div>
        `;
        let Thtml = ` 
            <h3>${this.getPrintInfo(datas?.ptside,machineInfo).title}<span class="title_desc" latag="${this.getPrintInfo(datas?.ptside,machineInfo).latagWord_Notice}">${this.getPrintInfo(datas.ptside,machineInfo).questionWord}</span><img class="personal_text_close" latag="${this.getPrintInfo(datas.ptside,machineInfo).latagWord_Cancel}" src="//p4.lefile.cn/product/adminweb/2021/08/03/3Bg8XXy391KuwuDypqptVix4J-3323.png"></h3>
            <div class="personal_img_content">
                <div class="personal_img_content_l">
                    <img class='previewInkjetImg' style='width:320px; height:320px; margin-left:32px;' src='' thumb_src='' />
                </div>
                <div class="personal_img_content_r">
                    <div class="personal_img_price_nav A_price_nav_box">
                        <ul class="A_price_nav_ul">

                        </ul>
                    </div>
                    <div class="personal_imgs_box">

                    </div>
                    <div class="personal_img_content_r_foot">
                        <b>喷绘价:¥1000</b><s>¥9999</s>
                        <div class="personal_text_C_cancel" latag="latag_pc_购物车_私定弹层_0_null_背面喷绘取消">取消</div>
                        <div class="personal_text_C_ensure sideA_submitOk" latag="latag_pc_购物车_私定弹层_0_null_背面喷绘确定">确定</div>
                    </div>
                </div>
            </div>
            <div class="a_c_desc">
              <div class="desc_title">平板背面定义</div>
              <img class="desc_pric" src="//p2.lefile.cn/fes/cms/2025/07/28/hvhcyszu5l51yayhm7w4wtsfgs44fd570371.png" >
              <div class="desc_text">平板的背板面（非屏幕面），有logo的一面</div>
            </div>
        `;
        let Lhtml = `
            <h3>左侧透明机箱喷绘<span class="title_desc" latag="latag_pc_购物车_L面私定弹层_0_null_什么是左侧透明机箱说明">什么是左侧透明机箱？</span><img class="personal_text_close" latag="latag_pc_购物车_L面私定弹层_0_null_L面喷绘取消" src="//p4.lefile.cn/product/adminweb/2021/08/03/3Bg8XXy391KuwuDypqptVix4J-3323.png"></h3>
            <div class="personal_img_content">
                <div class="personal_img_content_l">
                    <div class="green_tag">官方图库</div>
                    <img class='previewInkjetImg' style='width:320px;height:320px;margin-top:85px' src='' thumb_src='' />
                </div>
                <div class="personal_img_content_r">
                    <div class="personal_img_price_nav A_price_nav_box">
                        <ul class="A_price_nav_ul">
     
                        </ul>
                    </div>
                    <div class="personal_imgs_box">

                    </div>
                    <div class="personal_img_content_r_foot">
                        <b>喷绘价:¥1000</b><s>¥9999</s>
                        <div class="personal_text_C_cancel" latag="latag_pc_购物车_私定弹层_0_null_L面喷绘取消">取消</div>
                        <div class="personal_text_C_ensure sideL_submitOk" latag="latag_pc_购物车_私定弹层_0_null_L面喷绘确定">确定</div>
                    </div>
                </div>
            </div>
            <div class="a_c_desc">
                <div class="desc_title">左侧透明机箱定义</div>
                <img class="desc_pric" src="//p2.lefile.cn/fes/cms/2025/04/25/vhs81y5dv0w3u3s695w9rnn9051ex6842618.png" >
                <div class="desc_text">
                是指台式电脑机箱的侧面板采用透明材质设计（通常为钢化玻璃或亚克力），允许用户直接观察机箱内部硬件（如主板、显卡、散热器、RGB灯效等）的一种设计风格。                     
                </div>
            </div>
        `;
        let htmlStr = '';
        // 平板官喷根据machineProductType来判断 ptside也是A
        if (isTablet) {
            htmlStr = Thtml;
        // 台式机官喷
        } else if (datas?.ptside === 'L') {
            htmlStr = Lhtml;
        // 笔记本官喷
        } else if (datas?.ptside === 'A') {
            htmlStr = Ahtml;
        }
        $('.personal_img').html(htmlStr);
    }

    setItempersonalC() {
        var that = this;
        let data = this._model._parent._personalGoods._cSideData[0];
        let datas = '';
        this._model._parent._data.personalizations.map((item, index) => {
            if (item.ptside == 'C') {
                datas = item;
            }
        })
        this.setPtMode(datas?.ptmode);
        let isTablet = this._model._parent._personalGoods.machineInfo?.machineProductType === 'T' ? true : false;
        let tabletUrl = '';
        let signatureInfo, letteringInfo = null;
        let machineInfo = this._model._parent._personalGoods.machineInfo;
        signatureInfo = machineInfo?.mobileList?.find(item => item?.ptMode == '3');
        letteringInfo = machineInfo?.mobileList?.find(item => item?.ptMode == '2');

        // 仅保留 tabTitle 非空的 tab，若当前 ptMode 已被隐藏则强制切到第一个有效 tab
        const validMobileList = (machineInfo?.mobileList || []).filter(item => item?.tabTitle);
        const isCurrentValid = validMobileList.some(item => item?.ptMode == this.ptMode);
        const isForcedSwitch = !isCurrentValid && validMobileList.length > 0;
        if (isForcedSwitch) {
          this.setPtMode(validMobileList[0].ptMode);
        }

        //签名刻字
        if(this.ptMode == '3'){
            const activeObj = signatureInfo.subList?.find(item => item.ptPicCode == datas.ptpicCode);
            if(isForcedSwitch || !activeObj){
              // 强制切换 或 原签名下架：不做默认选中，等用户主动勾选；预览显示干净机器图
              this.setSubmitInfo(null);
              tabletUrl = machineInfo?.url;
              this.setPtUrl(tabletUrl);
            }else{
              this.setSubmitInfo(activeObj);
              this.setPtUrl(activeObj.ptUrl);
              tabletUrl = activeObj.ptUrl;
            }
        //自定义刻字
        }else{
          tabletUrl = machineInfo?.url;
          this.setPtUrl(tabletUrl);
        }
        
        // 购物车获取c面刻字的字段修改：activityPrice。 2022.10.31; 传给后端也会重新计算
        let html = ` <h2><i class="fr iconfont icon-close close_personal" tag="presonalCancel"></i>C面私人定制信息</h2>
        <p style="font-family: FZLTZHJW--GB1-0;font-size: 14px;font-weight:600;">C面刻字：（ ${data.activityPrice}元 ）</p>
        <div  style="font-family: FZLTZHJW--GB1-0;font-size: 14px;font-weight:600;" class="clearfix personal_form">
        <label class="fl label">刻字</label>
        <div class="fl textarea">
            <textarea maxlength="16" tag="onClickInput">${datas?.ptword}</textarea>
            <p class="tip">文字长度不能超过15个汉字，下面效果图只做参考，实际效果以刻字实物为准。</p>
        </div>
        </div>
        <div class="img_example">
        <img src="//p3.lefile.cn/product/adminweb/2021/03/30/QXP4diNiJo6S1mtKL4BQivvVz-2190.jpg" />
        </div>
        <div class="personal_bottom">
          <button  class="le_btn le_btn_solid cancel" tag="presonalCancel">关闭</button>
          <button class="le_btn le_btn_solid confirm" price="${data?.price}" priceName="${data?.priceName}" code="${data?.code}" tag="presonalOkC">确认</button>        
        </div>`;
        // 平板C面定义悬浮框
        let tablet_c_desc_html = `
          <div class="a_c_desc">
              <div class="desc_title">平板背面定义</div>
              <img class="desc_pric" src="//p2.lefile.cn/fes/cms/2025/07/28/hvhcyszu5l51yayhm7w4wtsfgs44fd570371.png" >
              <div class="desc_text">平板的背板面（非屏幕面），有logo的一面</div>
          </div>
        `;
        // 笔记本AC面定义悬浮框
        let noteBook_computer_ac_desc_html = `
          <div class="a_c_desc">
              <div class="desc_title">A面定义</div>
              <img class="desc_pric" src="https://item.lenovo.com.cn/series/product/xiaoxin/images/srdz_a_pic.jpeg" >
              <div class="desc_text">
                  即顶盖，是指合上屏幕就看到的那一面，也就是笔记本logo所在的那一面                     
              </div>
              <div class="desc_title">C面定义</div>
              <img class="desc_pric" src="https://item.lenovo.com.cn/series/product/xiaoxin/images/srdz_c_pic.jpeg" >
              <div class="desc_text">即键盘所在面（但不包括键盘）</div>
          </div>
        `;
        let Chtml = `
            <h3>${this.getPrintInfo(datas?.ptside,machineInfo).title}<span class="title_desc" latag="${this.getPrintInfo(datas?.ptside,machineInfo).latagWord_Notice}">${this.getPrintInfo(datas.ptside,machineInfo).questionWord}</span><img class="personal_text_close" latag="${this.getPrintInfo(datas.ptside,machineInfo).latagWord_Cancel}" src="//p4.lefile.cn/product/adminweb/2021/08/03/3Bg8XXy391KuwuDypqptVix4J-3323.png"></h3>
            <div class="personal_text_content">
                <div class="personal_text_content_l">
                    ${isTablet
                    ? `<div class="tablet-box">
                      ${this.getTabletLeft(machineInfo)}
                      </div>` 
                    : `${this.getNoteBookLeft(machineInfo)}`
                    }
                    <p class="personal_text_content_remind1">深色机型浅色刻字，浅色机型深色刻字</p>
                    <p class="personal_text_content_remind2">效果图只做参考，实际效果以刻字实物为准</p>
                </div>
                <div class="personal_text_content_r">
                    ${(() => {
                        const validMobileList = (machineInfo?.mobileList || []).filter(item => item?.tabTitle);
                        if (validMobileList.length === 0) return '';
                        const tabsHtml = validMobileList.map((item) => {
                          const target = item.ptMode === '3' ? 'signature' : 'lettering';
                          return `<div class="lettering_tabs_item" latag="latag_pc_购物车_${datas?.ptside}面私定弹层_${datas?.ptside}面刻字_切换tab按钮" data-target="${target}" data-ptmode=${item.ptMode}>${item.tabTitle}</div>`;
                        }).join('');
                        return `<div class="lettering-tabs">${tabsHtml}</div>`;
                    })()}
                    
                    <div class="lettering_content signature">
                    ${signatureInfo?.subList?.map((item, index) => {
                      return `<div class="lettering_content_signature_item">
                                  <div data-pturl="${item?.ptUrl}" 
                                  data-ptpiccode="${item?.ptPicCode}" 
                                  data-pteffecturl="${item?.ptEffectUrl}" 
                                  class="lettering_content_signature_itemImgBox ${this.submitInfo?.ptPicCode == item?.ptPicCode ? 'lettering_content_signature_itemImg_active' : 'lettering_content_signature_itemImg_default'}" 
                                  latag="latag_pc_购物车_${datas?.ptside}面私定弹层_${datas?.ptside}面刻字_选择艺人签名">    
                                      <img class="lettering_content_signature_itemImg" 
                                      src="${item?.ptEffectUrl}" />
                                  </div>
                                  <div class="lettering_content-signature_itemText">${item?.tabContent}</div>
                              </div>`
                    }).join('')}
                  </div>
                  
                  <div class="lettering_content lettering" style="position:relative">
                      <input id="text-input" maxlength="16" placeholder="请输入刻字内容..." />
                      <img class="carve_clear_input" latag="latag_pc_购物车_${datas?.ptside}面私定弹层_0_null_清空刻字输入" src="//p3.lefile.cn/fes/cms/2023/02/28/7f4uwox77b16mmfjiuxyza34cai6an460347.png">
                      <p class="personal_text_content_r_remind">最多可输入15个汉字或字符</p>
                      ${this.getSwitchTypeface(machineInfo?.mobileList)}
                      <div class="carve_emojis_box">
                          <div><span class="lenovo-emoji"></span></div>
                      </div>
                  </div>
                    <div class="personal_text_content_r_foot">
                        <b>刻字价:¥${data?.activityPrice ?? ''}</b>${(data && data.activityPrice != data.price) ? `<s>¥${data.price}</s>` : ''}
                        <div class="personal_text_C_cancel" latag="latag_pc_购物车_私定弹层_0_null_${datas?.ptside}面喷绘取消">取消</div>
                        <div class="personal_text_C_ensure sideC_submitOk" machineProductType="${machineInfo?.machineProductType}" currentPtMode="${this.ptMode}" ptside="${datas?.ptside}" pttype="${datas?.pttype}" price="${data?.price}" priceName="${data?.priceName}" code="${data?.code}" latag="latag_pc_购物车_私定弹层_0_null_${datas?.ptside}面喷绘取消">确定</div>
                    </div>
                </div>
            </div>
            ${isTablet ? tablet_c_desc_html : noteBook_computer_ac_desc_html}
        `;
        // setTimeout将绑定事件加入异步队列 等待dom挂载后再绑定 使事件生效
        setTimeout(() => {
          // 默认展示哪个内容
          $(`.lettering_tabs_item[data-ptmode=${this.ptMode}]`).addClass('lettering_tabs_itemActive');
          if(this.ptMode == '3'){
            $('.lettering').hide();
          }else{
            $('.signature').hide();
          }
          // 点击tab
          $('.lettering_tabs_item').off('click').on('click',function () {
              $('.lettering_tabs_item').removeClass('lettering_tabs_itemActive');
              $(this).addClass('lettering_tabs_itemActive');
              const target = $(this).data('target');
              const ptMode = $(this).data('ptmode');
              that.setPtMode(ptMode);
              let productUrl;
              //左边元素变化
              //签名刻字
              if(that.ptMode == '3'){
                // 有选中的明星数据 把选中的存起来
                if(that.submitInfo?.ptPicCode){
                  const activeObj = signatureInfo.subList.find(item => item.ptPicCode == that.submitInfo.ptPicCode)
                  that.setSubmitInfo(activeObj);
                  that.setPtUrl(activeObj.ptUrl);
                // 没有选中的 选第0个
                }else{
                  const currentPtUrl = signatureInfo.subList[0].ptUrl;
                  that.setSubmitInfo(signatureInfo.subList[0]);
                  that.setPtUrl(currentPtUrl);
                }
                //小框加上选中边框
                $(`.lettering_content_signature_itemImgBox[data-ptpiccode="${that.submitInfo.ptPicCode}"]`)
                .removeClass('lettering_content_signature_itemImg_default')
                .addClass('lettering_content_signature_itemImg_active');
                if(machineInfo.machineProductType == 'T'){
                  $('.tablet-C-detail-pc-img').attr('src',that.ptUrl);
                  $('.carve_main_preview_tablet').hide();
                }
                if(machineInfo.machineProductType == 'C'){
                  $('.personal_text_preview').html(`<img class="starSign_ptUrl" src="${that.ptUrl}">`)
                }
              //自定义刻字
              }else{
                that.setPtUrl(machineInfo?.url);
                if(machineInfo.machineProductType == 'T'){
                  $('.tablet-C-detail-pc-img').attr('src',machineInfo?.url);
                  $('.carve_main_preview_tablet').show();
                  const inputDom = $('#text-input');
                  $('.carve_main_preview_tablet').html(`${inputDom.val()}`)
                }
                if(machineInfo.machineProductType == 'C'){
                  $('.personal_text_preview').html(
                   `<img class="custom_Url" src="${machineInfo.url}" />
                    <div class="lenovo-emoji carve_main_preview_t"></div>
                    <div class="lenovo-emoji carve_main_preview_b"></div>`
                  );
                  const inputDom = $('#text-input');
                  $('.carve_main_preview_t').html(`${inputDom.val()}`)
                  $('.carve_main_preview_b').html(`${inputDom.val()}`)
                }
              }
              $('.lettering_content').hide();
              $('.' + target).show();
          })
          // 点击明星签名下面的小项
          $('.lettering_content_signature_itemImgBox').off('click').on('click',function () {
            
            const ptUrl = $(this).data('pturl');
            const ptPicCode = $(this).data('ptpiccode');
            const itemData = signatureInfo.subList.find(item => item.ptPicCode == ptPicCode);
            
            $('.lettering_content_signature_itemImgBox').each(function() {
              $(this).addClass('lettering_content_signature_itemImg_default')
                     .removeClass('lettering_content_signature_itemImg_active');
            });
            $(this).removeClass('lettering_content_signature_itemImg_default').addClass('lettering_content_signature_itemImg_active');
            if(machineInfo.machineProductType == 'C'){
              $('.starSign_ptUrl').attr('src',ptUrl);
            }
            if(machineInfo.machineProductType == 'Z'){
              $('.tablet-C-detail-pc-img').attr('src',ptUrl);
            }
            if(machineInfo.machineProductType == 'T'){
              $('.tablet-C-detail-pc-img').attr('src',ptUrl);
            }
            that.setSubmitInfo(itemData);
            that.setPtUrl(ptUrl);
            that.setPtMode(itemData.ptMode)
          });
          
          $('.font-item').off('click').on('click', function () {
            // 1. 切换选中状态
            $('.font-item').removeClass('active');
            $(this).addClass('active');
          
            // 2. 获取正确字段
            const fontId = $(this).data('fontid');
            const fontFamily = $(this).data('fontfamily');
            const ttfUrl = $(this).data('ttfurl');      // 新增
            const fontName = $(this).data('fontname');  // 新增
          
            // 3. 应用到输入框
            const inputFontFamily = `${fontFamily}, 'lenovo-emoji', 'Apple Color Emoji', 'Segoe UI Emoji', sans-serif`;
            $('#text-input').css('font-family', inputFontFamily);
          
            // 4. 应用到所有预览区
            if (machineInfo.machineProductType === 'T') {
              $('.carve_main_preview_tablet').css('font-family', fontFamily);
            } else {
              $('.carve_main_preview_t, .carve_main_preview_b').css('font-family', fontFamily);
            }
          
            // 5. 保存到实例（完整赋值）
            that.selectedFontId = fontId;
            that.ttfUrl = ttfUrl;
            that.fontName = fontName;
            that.selectedFontFamily = fontFamily;
            that.priewCarveText();  // 添加刷新预览
          });
          
          // 初始化默认字体
          const $fontItems = $('.font-item');
          if ($fontItems.length > 0) {
              const savedFontId = datas?.fontId;
              let $activeFont = null;
              if (savedFontId) {
                  $activeFont = $fontItems.filter((_, el) => $(el).data('fontid') == savedFontId);
              }
              if (!$activeFont || !$activeFont.length) {
                  $activeFont = $fontItems.eq(0);
              }
              // 高亮激活的字体项
              $fontItems.removeClass('active');
              $activeFont.addClass('active');

              // 获取字体数据
              const fontFamily = $activeFont.data('fontfamily');
              const fontId = $activeFont.data('fontid');
              const ttfUrl = $activeFont.data('ttfurl');
              const fontName = $activeFont.data('fontname');

              // 应用到实例属性
              that.selectedFontFamily = fontFamily;
              that.selectedFontId = fontId;
              that.ttfUrl = ttfUrl;
              that.fontName = fontName;

              // 应用到输入框
              const inputFontFamily = `${fontFamily}, 'lenovo-emoji', 'Apple Color Emoji', 'Segoe UI Emoji', sans-serif`;
              $('#text-input').css('font-family', inputFontFamily);

              // 应用到预览区（直接样式）
              if (machineInfo.machineProductType === 'T') {
                  $('.carve_main_preview_tablet').css('font-family', fontFamily);
              } else {
                  $('.carve_main_preview_t, .carve_main_preview_b').css('font-family', fontFamily);
              }

              // 刷新预览
              that.priewCarveText();
          } else {
              // 没有字体选择器（即 fontList 为空）时，设置默认字体栈
              const defaultUserFont = 'Helvetica Neue, Helvetica, Arial, Microsoft Yahei, 微软雅黑, PingFang SC, Heiti, sans-serif, SimSun, serif';
              const inputFontFamily = `${defaultUserFont}, 'lenovo-emoji', 'Apple Color Emoji', 'Segoe UI Emoji', sans-serif`;
              $('#text-input').css('font-family', inputFontFamily);
              that.selectedFontFamily = defaultUserFont;
              that.priewCarveText();
          }
        },0);
        
        $('.personal_text').html(Chtml);
    }
    
    getTabletLeft(machineInfo){
      let html = '';
      if(this.ptMode == '2'){
        html = `<img class="tablet-C-detail-pc-img" src="${this._model._parent._personalGoods.machineInfo?.url}">
                <div class="lenovo-emoji carve_main_preview_tablet" style="right:3%; bottom:22.5%"></div>`;
      }
      if(this.ptMode == '3'){
        html = `<img class="tablet-C-detail-pc-img" src="${this.ptUrl}">
                <div class="lenovo-emoji carve_main_preview_tablet" style="display:none; right:3%; bottom:22.5%"></div>`;
      }
      return html;
    }
    
    getNoteBookLeft(machineInfo){
      let html = '';
      if(this.ptMode == '2'){
        html = `<div class="personal_text_preview">
          <img class="custom_Url" src="${machineInfo.url}" />
          <div class="lenovo-emoji carve_main_preview_t"></div>
          <div class="lenovo-emoji carve_main_preview_b"></div>
        </div>`;
      }
      if(this.ptMode == '3'){
        html = `<div class="personal_text_preview">
          <img class="starSign_ptUrl" src="${this.ptUrl}">
        </div>`;
      }
      return html;
    }
    
    getPrintInfo(ptside, machineInfo) {
      let info = {
        title:'',
        questionWord:'',
        latagWord_Back:'',
        latagWord_Notice:'',
      }
      let privateInfo = {
        'A':{
          title:'A面喷绘',
          questionWord: '哪里为A/C面？',
          latagWord_Cancel: 'latag_pc_购物车_私人定制A面_0_null_取消',
          latagWord_Notice:'latag_pc_购物车_私人定制A面_0_null_A面/C面说明'
        },
        'C':{
          title:'C面刻字',
          questionWord: '哪里为A/C面？',
          latagWord_Cancel:'latag_pc_购物车_私人定制C面_0_null_取消',
          latagWord_Notice:'latag_pc_购物车_私人定制C面_0_null_A面/C面说明'
        },
        'L':{
          title:'官方图库',
          questionWord:'左侧透明机箱？',
          latagWord_Cancel:'latag_pc_购物车_私人定制L面_0_null_取消',
          latagWord_Notice: 'latag_pc_购物车_私人定制L面_0_null_L面说明'
        },
        'T':{
          // 平板 - 喷绘前端写 刻字从后端取
          title: ptside === 'A' ? '背面喷绘' : machineInfo?.machineTitle,
          questionWord: '哪里是背面？',
          latagWord_Cancel:'latag_pc_购物车_私人定制背面_0_null_取消',
          latagWord_Notice: 'latag_pc_购物车_私人定制背面_0_null_背面说明'
        }
      }
      if(machineInfo?.machineProductType === 'T'){
        info = { ...privateInfo[machineInfo?.machineProductType] };
      }else{
        info = { ...privateInfo[ptside] };
      } 
      return info;
    }
    
    getSwitchTypeface(mobileList){
      let customItem = this._model._parent._personalGoods?._cSideData?.[0] || {};
      let apiFontList = customItem?.fontList || [];
      
      // 如果没有字体列表，返回空字符串（不显示字体选择器）
      if (apiFontList.length === 0) {
        return '';
      }
    
      let fontList = [];
      if (apiFontList.length > 0) {
        fontList = apiFontList.map(item => ({
          fontId: item.fontId,
          fontName: item.fontName,
          ttfUrl: item.ttfUrl,
          fontFamily: item.fontId + '-font'
        }));
      }
    
      let style = document.createElement('style');
      let css = '';
      fontList.forEach(item => {
        if (item?.ttfUrl) {
          css += `
            @font-face {
              font-family: '${item.fontFamily}';
              src: url('${item.ttfUrl}') format('truetype');
            }
          `;
        }
      });
      if(css){
        style.innerHTML = css;
        document.head.appendChild(style);
      }
    
      let html = `<div class="font-selector">
        <p class="font-label">选择字体</p>
        <div class="font-list">`;
    
      fontList.forEach((font, index) => {
        const activeClass = index === 0 ? 'active' : '';
        html += `<div class="font-item ${activeClass}" 
        data-fontid="${font?.fontId}" 
        data-fontfamily="${font?.fontFamily}"
        data-ttfurl="${font?.ttfUrl}"
        data-fontname="${font?.fontName}">
            <span class="font-preview" style="font-family:${font?.fontFamily}">Aa</span>
            <span class="font-name" style="font-family:${font?.fontFamily}">${font?.fontName}</span>
        </div>`;
      });
    
      html += `</div></div>`;
      return html;
    }

    render(es, index, sec, materialCode) {
        
        let html = "";
        if (es == "A" || es == "L") {
            this.setItempersonal();
            
            let indexLeft = 0
            let indexRight = ''
            let personalizations = this._model._parent._data.personalizations
            let data = this._model._pictures
            if (personalizations && personalizations.length > 0) {
                let datas = ''
                this._model._parent._data.personalizations.map((item, index) => {
                    if (item.ptside == 'A' || item.ptside == 'L') {
                        datas = item
                    }
                })
                data.map((item, index) => {
                    item.picArr.map((items, indexa) => {
                        if (items.code == datas.ptpicCode) {
                            indexLeft = index
                            this.indexLeft = index
                            indexRight = indexa
                            this.indexRight = indexa
                            this._coder = item.cateCode
                            this._codes = items.code
                        }
                    })

                })
            }
            $("#cart_pc_wrapper .personal_img .nav li").eq(index).addClass("active");
            $("#cart_pc_wrapper .personal_type_box .type_item").eq(0).addClass("active")
            $("#cart_pc_wrapper .personal_img .type_slide .slide_content li").eq(indexLeft).addClass("active")
            $("#cart_pc_wrapper .personal_img .type_list_box .type_list").eq(indexLeft).show()
            $("#cart_pc_wrapper  .type_list_box .type_list").eq(indexLeft).find("li[tag='onMouseoverTag']").eq(indexRight).addClass("active");
        } else {
            // html =`${this.setItempersonalC()}`
            this.setItempersonalC();
        }
        // $(".pop_right").html(html);
        this._el = $("div.extra_item_middle");
        this._els = $("div.personal_img");
        this._elC = $("div.personal_text");
        this.materialCode = materialCode;
        // 每次render都清空选择了几件服务
        this.regEvent(es);

    }

    regEvent(es) {
        let that = this;
        const goodsCodes = that._model._parent._data.id
        const imgPriceData = {
            price: '',
            activityPrice: '',
            priceName: '',
            codeNav: ''
        }
        const selectedImgMsg = {
            code: '',
            name: '',
            price: '',
            priceName: '',
            codeNav: ''
        }

        // 获取选中图片的pttype
        function getSelectedImgPttype(data, ptpicCode) {
            for (let item of data) {
                // 找到当前选中的官喷图片对象
                const img = item.picArr.find(imgs => imgs.code === ptpicCode)
                if (img) {
                    return img.pttype || 1
                }
            }
            return 1
        }

        commonFun()
        switch (es) {
            case "A":
                aFaceLogical(es)
                break;
            case "C":
                cFaceLogical()
                break;
            case "L":
                aFaceLogical(es)
                break;
            default:
        }
        function cFaceLogical() {
          let emojiMap = new Map();   // 新增：存储表情符号映射
            // 原始已选中的 C 面私定信息的刻字类型
            const originalPtmode = that._model._parent._data.personalizations?.find(item => item?.ptside == 'C')?.ptmode;
            // 仅当原选中就是自定义刻字('2')时才回显刻字文案；
            // 若原选中是明星刻字('3')（例如签名已下架被强制切到自定义刻字），则自定义输入框应为空，避免把明星签名文案错误回显
            if(that.ptMode == '2' && originalPtmode == '2'){
              $('#text-input').val(that._model.cPTword);
            }
            priewCarveText()

            $('.carve_clear_input').on('click', function () {
                $('#text-input').val('')
                priewCarveText()
                $(this).hide()
            })

            API.getPersonalCarveEmojis().then(res => {
                const data = res.t.res.emojiList
                const emojiList = data.reduce((pre, cur, index) => {
                    return pre + `<div><span class="emoji_item_font emoji lenovo-emoji" emoji="${cur.code.replace('&#', '_emoji_')}">${cur.code}</span></div>`
                }, ``)
                $('.carve_emojis_box').html(emojiList)
                choiceEmoji()
                // 表情列表加载完成，构建 emojiMap 后刷新预览
                handleEmojiMap();    // 确保 emojiMap 已构建
                priewCarveText();    // 刷新预览
            }).catch(err => {
                console.log(err, 'err');
            })

            // 计算input内容长度
            function getInputTextLen(textArr = []) {
                const emojiMap = handleEmojiMap();
                const inputTextLen = textArr.reduce((pre, cur) => {
                    return pre + (emojiMap.get(cur) ? 1.5 : 1)
                }, 0);
                return inputTextLen;
            }

            // 生成emoji map
            function handleEmojiMap() {
              emojiMap.clear();   // 新增：清空
              $('.emoji_item_font').each((index, item) => {
                  const key = $(item).html();
                  const val = $(item).attr('emoji').replace('_emoji_', '&#');
                  emojiMap.set(key, val);
              });
              return emojiMap;
            }

            // 选择emoji
            function choiceEmoji() {
                $('.emoji').on('mousedown', function () {
                    $(this.parentElement).addClass('choice_expression');
                }).on('mouseup', function () {
                    $(this.parentElement).removeClass('choice_expression');
                });
                $('.emoji').on('click', function () {
                    $('.carve_clear_input').show()
                    const inputDom = document.getElementById('text-input')
                    const inputArr = inputDom.value.split('')
                    const inputTextLen = getInputTextLen(inputArr)
                    if (inputTextLen >= 14) {
                        $('.personal_text_content_r_remind').css('color', '#EF1E0B')
                        setTimeout(() => {
                            $('.personal_text_content_r_remind').css('color', '#BDBDBD')
                        }, 3000)
                        return
                    } else {
                        const index = inputDom.selectionStart
                        if (index === inputArr.length) {
                            inputDom.value = inputDom.value + this.innerText
                        } else {
                            inputArr.splice(index, 0, this.innerText)
                            inputDom.value = inputArr.join('')
                        }
                        inputDom.focus()
                        inputDom.setSelectionRange(index + 1, index + 1)
                    }
                    priewCarveText()
                })
            }
            
            function priewCarveText() {
                const inputDom = $('#text-input');
                const text = inputDom.val() || '';
                const isTablet = that._model._parent._personalGoods.machineInfo?.machineProductType === 'T';
                
                // 获取当前选中的字体族（如果有字体选择器则用选中的，否则用默认字体栈）
                let currentFontFamily = that.selectedFontFamily;
                if (!currentFontFamily) {
                    // 默认字体栈
                    currentFontFamily = 'Helvetica Neue, Helvetica, Arial, Microsoft Yahei, 微软雅黑, PingFang SC, Heiti, sans-serif, SimSun, serif';
                }
                
                // 将文本转换为带 span 的 HTML
                let html = '';
                for (let ch of text) {
                    if (emojiMap.has(ch)) {
                        // 表情字符：使用 emoji 专用类（样式由外部 CSS 定义）
                        html += `<span class="pc-emoji-font">${ch}</span>`;
                    } else {
                        // 普通字符：使用当前选中的字体族
                        html += `<span style="font-family: ${currentFontFamily};">${ch}</span>`;
                    }
                }
                
                if (isTablet) {
                    $('.carve_main_preview_tablet').html(html);
                } else {
                    $('.carve_main_preview_t').html(html);
                    $('.carve_main_preview_b').html(html);
                }
            }
            
            //挂载到实例上，供外部（字体点击回调）调用
            that.priewCarveText = priewCarveText;

            // oninput是否为拼音输入 
            let recoverTime = null
            let flag = true;
            let inputTextArrEnd = []
            $('#text-input').on('compositionstart', function () {
                const inputDom = document.getElementById('text-input')
                const compositionstartIndex = inputDom.selectionStart
                inputTextArrEnd = inputDom.value.split('').slice(compositionstartIndex)
                flag = false;
            })
            $('#text-input').on('compositionend', function () {
                const inputDom = document.getElementById('text-input')
                let index = inputDom.selectionStart - inputTextArrEnd.length
                const inputTextArr = inputDom.value.split('')
                while (getInputTextLen(inputTextArr) > 15) {
                    $('.personal_text_content_r_remind').css('color', '#EF1E0B')
                    inputTextArr.splice(--index, 1)
                }
                if (recoverTime !== null) {
                    clearTimeout(recoverTime);
                }
                recoverTime = setTimeout(() => {
                    $('.personal_text_content_r_remind').css('color', '#BDBDBD')
                }, 3000)
                inputDom.value = inputTextArr.join('')
                flag = true;
                $('#text-input').trigger("input")
            })
            let time = null
            // oninput监听
            $('#text-input').on('input', function () {
                if (!flag) return
                const inputDom = document.getElementById('text-input')
                const inputTextArr = inputDom.value.split('')
                let inputTextLen = getInputTextLen(inputTextArr)
                let index = inputDom.selectionStart
                if (inputTextLen > 15) {
                    $('.carve_clear_input').show()
                    $('.personal_text_content_r_remind').css('color', '#EF1E0B')
                    while (inputTextLen > 15) {
                        inputTextArr.splice(index - 1, 1)
                        index--
                        inputTextLen = getInputTextLen(inputTextArr)
                    };
                    inputDom.value = inputTextArr.join('')
                    if (recoverTime !== null) {
                        clearTimeout(recoverTime);
                    }
                    recoverTime = setTimeout(() => {
                        $('.personal_text_content_r_remind').css('color', '#BDBDBD')
                    }, 3000)
                } else if (inputTextLen > 0 && inputTextLen <= 15) {
                    $('.carve_clear_input').show()
                } else {
                    $('.carve_clear_input').hide()
                    priewCarveText()
                    return
                }
                if (time !== null) {
                    clearTimeout(time);
                }
                time = setTimeout(() => {
                    API.riskCheck({
                        sts: 'e40e7004-4c8a-4963-8564-31271a8337d8',
                        text: inputDom.value
                    }).then(res => {
                        if (res.resps.ret == 0 && res.resps.isLegal == 0) {
                            priewCarveText()
                        } else {
                            var tips = '重新提交您的刻字内容，您可以尝试输入名字或祝福等，为设备添加个性风格';
                            Alert.showTip(tips);
                        }
                    }).catch(err => {
                        console.log(err, 'err');
                    })
                }, 500)
            })

            // 确定刻字
            $('.sideC_submitOk').on('click', function (e) {
                const machineProductType = $(this).attr('machineProductType');
                const ptmode = that.ptMode;
                const ptside = $(this).attr('ptside');
                const pttype = $(this).attr('pttype');
                // 所有设备类型的明星刻字
                if(ptmode == '3'){
                  // 明星签名 tab 下必须已选中一张签名（覆盖强制切换、原签名下架等未默认选中场景）
                  if(!that.submitInfo?.ptPicCode){
                    Alert.showTip('请选择签名');
                    return;
                  }
                  let code = $(this).attr('code');
                  let price = $(this).attr('price');
                  let priceID = $(this).attr('priceName');
                  let ptword = that.submitInfo.ptWord;
                  let pturl = that.submitInfo.ptUrl
                  let spurl = that.submitInfo.ptEffectUrl
                  let ptpicCode = that.submitInfo.ptPicCode
                  let params = { price: price, priceID: priceID, ptmode: ptmode, ptside: ptside, pttype, ptword , ptcode: code, pturl, spurl, ptpicCode }
                  let personalizations = that._model._parent._data.personalizations
                  personalizations.map((item, index) => {
                      if (item.ptside == params.ptside) {
                          personalizations.splice(index, 1, params)
                      }
                  })
                  that._model._parent.modifyItemFromCart({
                      opsType: 4,
                      content: JSON.stringify(personalizations)
                  }).then(modifyRes => {
                      //console.log('C面刻字修改成功', modifyRes);
                      $('.personal_box').hide();
                      $('.pc_mask').hide();
                      $util.toggleBodyScroller(false);
                  }).catch(modifyErr => {
                      console.log('C面修改刻字接口error:', modifyErr)
                  });
                  return;
                }
                // 自定义刻字
                const inputText = $('#text-input').val()
                if (!inputText.replace(/\s+/g, '')) {
                    Alert.showTip('请输入刻字内容')
                    return
                }
                // 转义emoji
                function emojiConvert(text = '') {
                    const emojiMap = handleEmojiMap();
                    let dto = '';
                    text.split('').forEach((item) => {
                        dto += emojiMap.get(item) ? emojiMap.get(item) : item;
                    });
                    return dto;
                }
                const text = emojiConvert($('#text-input').val())
                if (text.length === 0) {
                    Alert.showTip('请输入刻字内容')
                    return;
                }
                try {
                    // 2022-11-21 购物车新增c面刻字风控pc
                    API.riskCheck({
                        sts: 'e40e7004-4c8a-4963-8564-31271a8337d8',
                        text: text
                    }).then(res => {
                        //console.log('风控risk', res)
                        if (res.resps.ret == 0 && res.resps.isLegal == 0) {
                            let code = $(this).attr('code')
                            let price = $(this).attr('price')
                            let priceID = $(this).attr('priceName')
                            let pturl = ''
                            if(that._model._parent._personalGoods.machineInfo?.mobileList?.length > 0){
                              pturl = that._model._parent._personalGoods.machineInfo?.mobileList?.find(item => item?.ptMode == '2')?.ptUrl;
                            }else{
                              pturl = that._model._parent._personalGoods.machineInfo.ptUrl;
                            }
                            let params = { 
                              price: price, 
                              priceID: priceID, 
                              ptmode: 2, 
                              ptside: 'C', 
                              pttype: 1, 
                              ptword: text, 
                              ptcode: code, 
                              pturl, 
                              fontId: that.selectedFontId,
                              ttfUrl: that.ttfUrl,
                              fontName: that.fontName,
                            }
                            let personalizations = that._model._parent._data.personalizations
                            personalizations.map((item, index) => {
                                if (item.ptside == params.ptside) {
                                    personalizations.splice(index, 1, params)
                                }
                            })
                            that._model._parent.modifyItemFromCart({
                                opsType: 4,
                                content: JSON.stringify(personalizations)
                            }).then(modifyRes => {
                                //console.log('C面刻字修改成功', modifyRes);
                                $('.personal_box').hide();
                                $('.pc_mask').hide();
                                $util.toggleBodyScroller(false);
                            }).catch(modifyErr => {
                                console.log('C面修改刻字接口error:', modifyErr)
                            })
                        } else {
                            var tips = '重新提交您的刻字内容，您可以尝试输入名字或祝福等，为设备添加个性风格';
                            Alert.showTip(tips);
                        }
                    }).catch(err => {
                        console.log('risk check pc失败', err)
                    });
                } catch (e) {
                    console.log('刻字修改接口err', e)
                }
            })
        }

        // C/A面公共方法
        function commonFun() {
            // 关闭AC面
            $('.personal_text_close').on('click', function () {
                $('.personal_box').hide()
                $('.pc_mask').hide()
                $util.toggleBodyScroller(false);
            })
            $('.personal_text_C_cancel').on('click', function () {
                $('.personal_box').hide()
                $('.pc_mask').hide()
                $util.toggleBodyScroller(false);
            })
            // AC面解释显示与隐藏
            $('.title_desc').on('mouseenter', () => {
                $('.a_c_desc').css('display', 'block')
            })
            $('.title_desc').on('mouseleave', () => {
                $('.a_c_desc').css('display', 'none')
            })
        }

        function aFaceLogical(ptside) {
            const navPriceData = that._model._aSideData
            const imgData = that._model._pictures
            selectedImgMsg.code = that._codes
            let { typeIndex, imgIndex } = findImgPosition(imgData, Number(selectedImgMsg.code))
            typeIndex = typeIndex >= 0 ? typeIndex : 0
            imgIndex = imgIndex >= 0 ? imgIndex : 0
            selectedImgMsg.code = imgData[typeIndex].picArr[imgIndex].code
            selectedImgMsg.name = imgData[typeIndex].picArr[imgIndex].name
            renderAPriceNav(navPriceData)
            renderAClassNavImgs(imgData, typeIndex, imgIndex)

            // 渲染A面图片价格导航
            function renderAPriceNav(data) {
                const navPriceList = data.reduce((pre, cur, index) => {
                    return pre + `<li latag='latag_pc_购物车_${ptside}面_${index}_null_价格${cur.showPrice}' class="A_price_nav_li" price="${cur.price}" priceName="${cur.showPrice}" activityPrice="${cur.activityPrice}" code="${cur.code}">${cur.showPrice}</li>`;
                }, ``)
                $('.A_price_nav_ul').html(navPriceList)
                const aPriceCode = Number(that._model.aPriceCode) || Number(that._model._aSideData[0].code)
                const index = data.findIndex(item => item.code == aPriceCode)
                $('.A_price_nav_ul>li').eq(index).addClass('A_price_nav_li_active')
                imgPriceData.codeNav = selectedImgMsg.codeNav = data[index].code
                imgPriceData.price = selectedImgMsg.price = data[index].price
                imgPriceData.priceName = selectedImgMsg.priceName = data[index].priceName
                imgPriceData.activityPrice = data[index].activityPrice
                if (imgPriceData.activityPrice !== imgPriceData.price) {
                    $('.personal_img_content_r_foot>b').text('喷绘价:¥' + imgPriceData.activityPrice)
                    $('.personal_img_content_r_foot>s').text('¥' + imgPriceData.price)
                } else {
                    $('.personal_img_content_r_foot>b').text('喷绘价:¥' + imgPriceData.activityPrice)
                    $('.personal_img_content_r_foot>s').text('')
                }
                choiceAPriceNav()
            }

            // 渲染A面图片类型导航及图片
            function renderAClassNavImgs(data, typeIndex, imgIndex) {
                let groupsIndex = parseInt(imgIndex / 12)
                const imgList = data.reduce((pre, cur, index) => {
                    const imgsData = cur.picArr
                    const imgLists = (imgsData.length > 12 ? imgsData.slice(groupsIndex * 12, 12 + groupsIndex * 12) : imgsData).reduce((pre, cur) => {
                        return pre + `<img latag='latag_pc_购物车_A面官方喷绘图_${index}_${cur.path}_${cur.name}' code="${cur.code}" name="${cur.name}" src="${cur.path}">`
                    }, ``)
                    return pre + `
                        <div class="personal_imgs_box_nav_img">
                            <div class="personal_img_box_calssName">${cur.cateName}</div>
                            <div class="personal_imgs_class_box">${imgLists}</div>
                            ${imgsData.length > 12 ? `<div class="paging"><div class="up_imgs" cateCode="${cur.cateCode}"><</div><div class="down_imgs" cateCode="${cur.cateCode}">></div></div>` : ''}
                        </div>
                    `
                }, ``)
                $('.personal_imgs_box').html(imgList)
                $('.down_imgs').addClass('paging_up_down_active')
                if (typeIndex >= 0 && imgIndex >= 0) {
                    const imgssData = data[typeIndex].picArr
                    const initImg = $('.personal_imgs_box_nav_img').eq(typeIndex).find('img').eq(imgIndex % 12)
                    const down_imgs = $('.personal_imgs_box_nav_img').eq(typeIndex).find('.down_imgs')
                    const initPaging = $('.personal_imgs_box_nav_img').eq(typeIndex).find('.paging')
                    initImg.addClass('personal_imgs_class_box_img_active')
                    $(initPaging).attr('clickNum', groupsIndex)
                    getOfficialImg(initImg.attr('code'), initImg.attr('src'))
                    if ((groupsIndex + 1) * 12 > imgssData.length) {
                        $(down_imgs).removeClass('paging_up_down_active')
                        $(down_imgs).siblings().addClass('paging_up_down_active')
                    } else if (groupsIndex > 0) {
                        $(down_imgs).siblings().addClass('paging_up_down_active')
                    }
                }
                choiceAimgs();
                pagingEvent(data);

            }

            // 选择A面价格图片价格导航
            function choiceAPriceNav() {
                $('.A_price_nav_li').on('click', function () {
                    $(this).siblings().removeClass('A_price_nav_li_active')
                    $(this).addClass('A_price_nav_li_active')
                    imgPriceData.price = $(this).attr('price')
                    imgPriceData.activityPrice = $(this).attr('activityprice')
                    imgPriceData.codeNav = $(this).attr('code')
                    imgPriceData.priceName = $(this).attr('pricename')

                    API.getPersonalPictures({ code: $(this).attr('code') }).then(res => {
                        const data = res.t.data
                        const { typeIndex, imgIndex } = findImgPosition(data, Number(selectedImgMsg.code))
                        renderAClassNavImgs(data, typeIndex, imgIndex)
                    }).catch(err => {
                        console.log(err);
                    })
                })
            }

            // 获取官方喷绘效果图
            function getOfficialImg(code, src) {
                $('.personal_img_content_l>img').attr('src', src).attr('thumb_src', src);
                let src_url = '';
                let thumb_src_url = '';
                API.getPersonalPrint({ code: code, materialNumber: that.materialCode, goodsCodes }).then(res => {
                    if (res.code == 0) {
                      src_url = res.t && res.t.data && res.t.data[0];
                      thumb_src_url = src;
                    } else {  
                      src_url = src;
                      thumb_src_url = src;
                    }
                }).catch(err => {
                    console.log(err, 'err');
                    src_url = src;
                    thumb_src_url = src;
                }).finally(()=>{
                  $('.personal_img_content_l>img').attr('src', src_url).attr('thumb_src', thumb_src_url);
                })
            }

            // 选择A面喷绘图片
            function choiceAimgs() {
                $('.personal_imgs_class_box').on('click', function (e) {
                    const imgDom = e.target
                    if ($(imgDom)[0].tagName === 'DIV') return  /* 防止点击非IMG */
                    selectedImgMsg.code = $(imgDom).attr('code')
                    selectedImgMsg.name = $(imgDom).attr('name')
                    $('.personal_imgs_box img').removeClass('personal_imgs_class_box_img_active')
                    $(imgDom).addClass('personal_imgs_class_box_img_active')
                    API.getPersonalPrint({ code: $(imgDom).attr('code'), materialNumber: that.materialCode, goodsCodes }).then(res => {
                        if (res.code == 0) {
                            $('.personal_img_content_l>img').attr('src', res.t && res.t.data && res.t.data[0]).attr('thumb_src', $(imgDom).attr('src'));
                        } else {
                            $('.personal_img_content_l>img').attr('src', `${$(imgDom).attr('src')}`).attr('thumb_src', $(imgDom).attr('src'));
                        }
                    }).catch(err => {
                        console.log(err, 'err');
                        $('.personal_img_content_l>img').attr('src', `${$(imgDom).attr('src')}`).attr('thumb_src', $(imgDom).attr('src'));
                    })
                    if (imgPriceData.price !== imgPriceData.activityPrice) {
                        $('.personal_img_content_r_foot>b').text('喷绘价:¥' + imgPriceData.activityPrice)
                        $('.personal_img_content_r_foot>s').text('¥' + imgPriceData.price)
                    } else {
                        $('.personal_img_content_r_foot>b').text('喷绘价:¥' + imgPriceData.activityPrice)
                        $('.personal_img_content_r_foot>s').text('')
                    }
                    selectedImgMsg.price = imgPriceData.price
                    selectedImgMsg.priceName = imgPriceData.Name
                    selectedImgMsg.codeNav = imgPriceData.codeNav
                })
            }

            // 定位官方效果图
            function findImgPosition(data, ptpicCode) {
                let typeIndex = 0
                let imgIndex = 0
                typeIndex = data.findIndex(item => {
                    imgIndex = item.picArr.findIndex(imgs => {
                        return imgs.code === ptpicCode
                    })
                    return imgIndex >= 0
                })
                return { typeIndex, imgIndex }
            }

            // A面分页事件 传入最新请求的当前tab类下的图片数组
            function pagingEvent(imgsData) {
                $('.down_imgs').on('click', function () {
                    if (!$(this.parentElement).attr('clickNum')) $(this.parentElement).attr('clickNum', 0)
                    let clickNum = Number($(this.parentElement).attr('clickNum'))
                    clickNum++
                    const cateCode = $(this).attr('cateCode')
                    const cateImgsData = imgsData.filter(item => item.cateCode == cateCode)[0].picArr
                    if (12 + clickNum * 12 < cateImgsData.length || clickNum * 12 <= cateImgsData.length) {
                        const data = cateImgsData.slice(clickNum * 12, 12 + clickNum * 12)
                        const cateImgsList = data.reduce((pre, cur) => {
                            return pre + `<img code="${cur.code}" name="${cur.name}" src="${cur.path}">`
                        }, ``)
                        $(this.parentElement).siblings('.personal_imgs_class_box').html(cateImgsList)
                        $(this.parentElement).attr('clickNum', clickNum)
                        $(this).siblings().addClass('paging_up_down_active')
                        if ((clickNum + 1) * 12 > cateImgsData.length) {
                            $(this).removeClass('paging_up_down_active')
                        } else {
                            $(this).siblings().addClass('paging_up_down_active')
                        }
                        const imgIndex = data.findIndex(item => item.code == Number(selectedImgMsg.code))
                        if (imgIndex > -1) $(this.parentElement).siblings('.personal_imgs_class_box').find('img').eq(imgIndex).addClass('personal_imgs_class_box_img_active')
                    } else {
                        clickNum--
                        $(this.parentElement).attr('clickNum', clickNum)
                        $(this).removeClass('paging_up_down_active')
                    }

                })
                $('.up_imgs').on('click', function () {
                    if (!$(this.parentElement).attr('clickNum')) $(this.parentElement).attr('clickNum', 0)
                    let clickNum = Number($(this.parentElement).attr('clickNum'))
                    clickNum--
                    const cateCode = $(this).attr('cateCode')
                    const cateImgsData = imgsData.filter(item => item.cateCode == cateCode)[0].picArr
                    if (clickNum >= 0) {
                        const data = cateImgsData.slice(clickNum * 12, 12 + clickNum * 12)
                        const cateImgsList = data.reduce((pre, cur) => {
                            return pre + `<img code="${cur.code}" name="${cur.name}" src="${cur.path}">`
                        }, ``)
                        $(this.parentElement).siblings('.personal_imgs_class_box').html(cateImgsList)
                        $(this.parentElement).attr('clickNum', clickNum)
                        if ((clickNum - 1) < 0) {
                            $(this).removeClass('paging_up_down_active')
                            $(this).siblings().addClass('paging_up_down_active')
                        } else {
                            $(this).siblings().addClass('paging_up_down_active')
                        }
                        const imgIndex = data.findIndex(item => item.code == Number(selectedImgMsg.code))
                        if (imgIndex > -1) $(this.parentElement).siblings('.personal_imgs_class_box').find('img').eq(imgIndex).addClass('personal_imgs_class_box_img_active')
                    } else {
                        $(this.parentElement).attr('clickNum', 0)
                    }
                })
            }
        }

        $(document).on("click", "[tag='srdz_style_bottombtn']", function () {
            if (that.page < that.totalPage) {
                that.page++;
                (that.w) -= $('.slide_content').height();;
                $(".slide_content").find('ol.type').animate({ top: that.w + 'px' }, 300);
                // that.setButtonShowHide();
            }
        });
        $(document).on("click", "[tag='srdz_style_topbtn']", function () {

            if (that.page > 1) {
                that.page--;
                (that.w) += $('.slide_content').height();;
                $(".slide_content").find('ol.type').animate({ top: that.w + 'px' }, 300);
                // self.setButtonShowHide();
            }
        });
        this._els.off("click", "li[tag='onClicknavLi']").on("click", "li[tag='onClicknavLi']", function (e) {
            var index = $(this).attr("index");
            var code = $(this).attr("codeNav");
            $('.personal_img').html('')
            that._model._parent.getPersonalPicturess({ code: code }).then(
                x => {
                    that.setItempersonal()
                    $("#cart_pc_wrapper .personal_img .nav li").eq(index).addClass("active");
                    $("#cart_pc_wrapper .personal_type_box .type_item").eq(0).addClass("active")


                    let code = $("[tag='onMouseoverTag'].active").attr('code')
                    that.indexRight = ''
                    let arrsbb = false
                    if (!code) {
                        let arr = that._model._parent._personalGoods._pictures
                        arr.map((item, index) => {
                            if (item.cateCode = that._coder) {
                                that.indexLeft = index
                            }
                            item.picArr.map((items, indexs) => {
                                if (items.code == that._codes) {
                                    that.indexRight = indexs
                                    arrsbb = true
                                    $("#cart_pc_wrapper .personal_img .type_slide .slide_content li").eq(that.indexLeft).addClass("active").siblings().removeClass('active')
                                    $("#cart_pc_wrapper .personal_img .type_list_box .type_list").eq(that.indexLeft).show()
                                    $("#cart_pc_wrapper  .type_list_box .type_list").eq(that.indexLeft).find("li[tag='onMouseoverTag']").eq(that.indexRight).addClass("active");

                                    // $("[tag='onMouseoverTag']").eq(indexs).addClass('active')
                                }
                            })
                        })
                    }
                    if (!arrsbb) {
                        $("#cart_pc_wrapper .personal_img .type_slide .slide_content li").eq(0).addClass("active")
                        $("#cart_pc_wrapper .personal_img .type_list_box .type_list").eq(0).show()
                    }

                }

            ).catch(err => {
                that.setItempersonal()
            });
        })
        this._els.off("click", "li[tag='onClickslideLi']").on("click", "li[tag='onClickslideLi']", function (e) {
            var index = $(this).attr("index");
            $(this).parents(".type_item").find(".type_list_box .type_list").hide().eq(index).show()
            $(this).addClass('active').siblings().removeClass('active')

        })
        this._els.off("click", "li[tag='onMouseoverTag']").on("click", "li[tag='onMouseoverTag']", function (e) {
            $(this).parents().find("[tag='onMouseoverTag']").removeClass('active')
            $(this).addClass('active')
            let code = $("[tag='onMouseoverTag'].active").attr('code')
            that._codes = code
            let codeb = $("[tag='onClickslideLi'].active").attr('codea')
            that._coder = codeb
        })
        this._els.off("mouseover", "li[tag='onMouseoverTag']").on("mouseover", "li[tag='onMouseoverTag']", function (e) {
            var x = 144;
            var y = 0;
            var left = $(this).position().left;
            var top = $(this).position().top;
            $(this).parents(".type_content").find(".large_img_area").css({
                'left': (left + x + 'px'),
                'top': (top + y + 'px'),
                'z-index': 9999
            }).show();
            // console.log($(this).attr("data-large"),'$(this).attr("data-large")')
            $(this).parents(".type_content").find(".large_img_area img").attr("src", $(this).attr("data-large"))
        })
        this._els.off("mouseout", "li[tag='onMouseoverTag']").on("mouseout", "li[tag='onMouseoverTag']", function (e) {
            $(this).parents(".type_content").find(".large_img_area").hide()
        })
        this._els.off("click", "[tag='presonalOk']").on("click", "[tag='presonalOk']", function (e) {
            let code = $("[tag='onMouseoverTag'].active").attr('code')
            let path = $("[tag='onMouseoverTag'].active").attr("data-large")
            let name = $("[tag='onMouseoverTag'].active").attr("name")
            let price = $("[tag='onClicknavLi'].active").attr("price")
            let priceName = $("[tag='onClicknavLi'].active").attr("priceName")
            let codeNav = $("[tag='onClicknavLi'].active").attr("codeNav")
            if (!code || !path) {
                Alert.showTip('请选择图片')
                return false
            }
            let params = {
                price: price, //价格
                priceID: priceName, //价格id
                ptmode: 1, //1 图片 2文字
                ptside: "A", //A面 C面 
                pttype: 1, //1 喷印 2 镭雕
                ptpicCode: code, //图片编码
                pturl: path, //图片地址 文字null
                picName: name, //选择的图片的名称
                ptcode: codeNav, //喷绘费/刻字费类型的唯⼀code
            }
            let personalizations = that._model._parent._data.personalizations
            personalizations.map((item, index) => {
                if (item.ptside == params.ptside) {
                    personalizations.splice(index, 1, params)
                }
            })
            // console.log(personalizations,'personalizations')
            that._model._parent.modifyItemFromCart({
                opsType: 4, content:
                    JSON.stringify(personalizations)
            });
            $('.personal_box').hide();
            $('.pc_mask').hide();
            $util.toggleBodyScroller(false);
        })
        // 购物车c面刻字点击确认 pc
        this._elC.off("click", "[tag='presonalOkC']").on("click", "[tag='presonalOkC']", function (e) {
            let text = $("[tag='onClickInput']").val()
            var myreg = /^[A-Za-z0-9\u4E00-\u9FA5，。,.!！?？\-—— ]+$/;
            // var myreg= new RegExp(/^([^\u4e00-\u9fa5A-Za-z0-9,.?!，。？！])*$/)

            if (text.length == 0) {
                Alert.showTip('请输入刻字内容')
                return false
            } else if (!myreg.test(text)) {
                Alert.showTip('有不符合要求的特殊字符，请重新输入')
                return false
            } else if (text.trimLeft().length != text.length) {
                Alert.showTip('首字母前不允许有空格，请重新输入')
                return false
            } else {
                try {
                    // 2022-11-21 购物车新增c面刻字风控pc
                    API.riskCheck({
                        sts: 'e40e7004-4c8a-4963-8564-31271a8337d8',
                        text: text
                    }).then(res => {
                        if (res.resps.ret == 0 && res.resps.isLegal == 0) {
                            let code = $(this).attr('code')
                            let price = $(this).attr('price')
                            let priceID = $(this).attr('priceName')
                            let params = { price: price, priceID: priceID, ptmode: 2, ptside: 'C', pttype: 1, ptword: text, ptcode: code }
                            let personalizations = that._model._parent._data.personalizations
                            personalizations.map((item, index) => {
                                if (item.ptside == params.ptside) {
                                    personalizations.splice(index, 1, params)
                                }
                            })
                            that._model._parent.modifyItemFromCart({ opsType: 4, content: JSON.stringify(personalizations) });
                            $('.personal_box').hide();
                            $('.pc_mask').hide();
                            $util.toggleBodyScroller(false);
                        } else {
                            var tips = '重新提交您的刻字内容，您可以尝试输入名字或祝福等，为设备添加个性风格';
                            Alert.showTip(tips);
                        }
                    }).catch(err => {
                        console.log('risk check pc失败', err)
                    });
                } catch (e) {
                    console.log('err', e)
                }
            }

        })
        this._els.off("click", "[tag='presonalCancel']").on("click", "[tag='presonalCancel']", function (e) {
            $('.personal_box').hide();
            $('.pc_mask').hide();
            $util.toggleBodyScroller(false);
        })
        this._elC.off("click", "[tag='presonalCancel']").on("click", "[tag='presonalCancel']", function (e) {
            $('.personal_box').hide();
            $('.personal_text').hide();
            $('.pc_mask').hide();
            $util.toggleBodyScroller(false);
        }),
            // A面确认喷绘
            $('.sideA_submitOk').off('click').on('click', function () {
                // let code = $("[tag='onMouseoverTag'].active").attr('code')
                // let path = $("[tag='onMouseoverTag'].active").attr("data-large")
                // let name = $("[tag='onMouseoverTag'].active").attr("name")
                // let price = $("[tag='onClicknavLi'].active").attr("price")
                // let priceName = $("[tag='onClicknavLi'].active").attr("priceName")
                // let codeNav = $("[tag='onClicknavLi'].active").attr("codeNav")
                let code = selectedImgMsg.code;
                let name = selectedImgMsg.name;
                let price = selectedImgMsg.price;
                let priceName = selectedImgMsg.priceName;
                let codeNav = selectedImgMsg.codeNav;
                let path = $('.previewInkjetImg').attr('thumb_src');
                if (!code || !path) {
                    Alert.showTip('请选择图片')
                    return false
                }
                // 从图片数据中获取pttype，如果是官喷使用接口返回的pttype
                const imgPttype = getSelectedImgPttype(that._model._pictures, Number(code))
                let params = {
                    price: price, //价格
                    priceID: priceName, //价格id
                    ptmode: 1, //1 图片 2文字
                    ptside: "A", //A面 C面 
                    pttype: imgPttype, //1 喷印 2 镭雕，从图片数据中获取
                    ptpicCode: code, //图片编码
                    pturl: path, //图片地址 文字null
                    picName: name, //选择的图片的名称
                    ptcode: codeNav, //喷绘费/刻字费类型的唯⼀code
                }
                let personalizations = that._model._parent._data.personalizations
                personalizations.map((item, index) => {
                    if (item.ptside == params.ptside) {
                        personalizations.splice(index, 1, params)
                    }
                })
                that._model._parent.modifyItemFromCart({
                    opsType: 4,
                    content: JSON.stringify(personalizations)
                }).then(res => {
                    $('.personal_box').hide();
                    $('.pc_mask').hide();
                    $util.toggleBodyScroller(false);
                }).catch(err => {
                    console.log('确认修改接口出错error:', err)
                })
            })
            
            // 台式机左侧透明机箱喷绘（L面）确认喷绘
            $('.sideL_submitOk').off('click').on('click', function () {
              // let code = $("[tag='onMouseoverTag'].active").attr('code')
              // let path = $("[tag='onMouseoverTag'].active").attr("data-large")
              // let name = $("[tag='onMouseoverTag'].active").attr("name")
              // let price = $("[tag='onClicknavLi'].active").attr("price")
              // let priceName = $("[tag='onClicknavLi'].active").attr("priceName")
              // let codeNav = $("[tag='onClicknavLi'].active").attr("codeNav")
              let code = selectedImgMsg.code;
              let name = selectedImgMsg.name;
              let price = selectedImgMsg.price;
              let priceName = selectedImgMsg.priceName;
              let codeNav = selectedImgMsg.codeNav;
              let path = $('.previewInkjetImg').attr('thumb_src');
              if (!code || !path) {
                  Alert.showTip('请选择图片')
                  return false
              }
              // 从图片数据中获取pttype，如果是官喷使用接口返回的pttype
              const imgPttype = getSelectedImgPttype(that._model._pictures, Number(code))
              let params = {
                  price: price, //价格
                  priceID: priceName, //价格id
                  ptmode: 1, //1 图片 2文字
                  ptside: "L", //A面 C面
                  pttype: imgPttype, //1 喷印 2 镭雕，从图片数据中获取
                  ptpicCode: code, //图片编码
                  pturl: path, //图片地址 文字null
                  picName: name, //选择的图片的名称
                  ptcode: codeNav, //喷绘费/刻字费类型的唯⼀code
              }
              let personalizations = that._model._parent._data.personalizations
              personalizations.map((item, index) => {
                  if (item.ptside == params.ptside) {
                      personalizations.splice(index, 1, params)
                  }
              })
              that._model._parent.modifyItemFromCart({
                  opsType: 4,
                  content: JSON.stringify(personalizations)
              }).then(res => {
                  $('.personal_box').hide();
                  $('.pc_mask').hide();
                  $util.toggleBodyScroller(false);
              }).catch(err => {
                  console.log('确认修改接口出错error:', err)
              })
            })
    }
}